import { useMediaQuery } from "@mui/material";
import { useSignal } from "@preact/signals-react";
import { useEffect } from "react";

export default function useSkuWidthMediaQueries() {
  const width = useSignal("")

  const isSmallScreen = useMediaQuery('(max-width: 600px)');
  const isMediumScreen = useMediaQuery('(max-width: 960px)');
  const isLargeScreen = useMediaQuery('(max-width: 1280px)');
  const isXLargeScreen = useMediaQuery('(max-width: 1600px)');
  const isXXLargeScreen = useMediaQuery('(min-width: 1601px)');

  useEffect(() => {
    if (isSmallScreen) {
      width.value = 60;
    } else if (isMediumScreen) {
        width.value = 100;
    } else if (isLargeScreen) {
        width.value = 200
    } else if (isXLargeScreen) {
        width.value = 300;
    } else if (isXXLargeScreen) {
        width.value = 350;
    }
  }, [isMediumScreen, isLargeScreen, isXLargeScreen, isXXLargeScreen]);

  return width.value;
}
